<template>
  <div style="min-height: 750px;">
    <b-row class="shoppingcart-title-row">
      <b-col sm="12" lg="2"></b-col>
      <b-col sm="12" lg="8"></b-col>
      <b-col sm="12" lg="2"></b-col>
    </b-row>

    <b-row class="shoppingcart-title-row" style="margin-bottom: 20px; border-bottom: solid 1px whitesmoke;">
      <b-col sm="12" md="2" lg="2"> </b-col>
      <b-col sm="12" md="4" lg="4">
        <i class="fa fa-desktop"></i>
        {{ StoreLangTranslation.data['my_shopcart'][StoreLang] }}
      </b-col>
      <b-col sm="12" md="4" lg="4" :style="StoreDevice.isMobile ? '' : 'text-align: right;'"></b-col>
      <b-col sm="12" md="2" lg="2"></b-col>
    </b-row>

    <b-row style="font-size: 16px;">
      <b-col sm="12" lg="2"></b-col>
      <b-col sm="12" lg="8">
        <b-row>
          <b-col sm="12" lg="9">
            <template v-if="d_loading">
              <b-spinner variant="primary" label="Spinning"></b-spinner>
            </template>
            <template v-else>
              <b-card no-body v-for="(shop_item, shop_item_index) in d_shopOrderList" class="b-card" style="min-height: 500px;">
                <b-card-header header-bg-variant="white" class="b-card-header p-1">
                   <b-row class="top-info-card" style="margin: 0px; padding: 5px;">
                    <b-col sm="12" lg="4">
                        <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['2'] && shop_item.shop_data.data['0']['2']['lang'] && shop_item.shop_data.data['0']['2']['lang'][StoreLang]">
                          <img :src="shop_item.shop_data.data['0']['2']['lang'][StoreLang]" style="width: 30px; margin-right: 3px;">
                        </template>
                        <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['2'] && shop_item.shop_data.data['0']['2']['val']">
                          <img :src="shop_item.shop_data.data['0']['2']['val']" style="width: 30px; margin-right: 3px;">
                        </template>
                        <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['1'] && shop_item.shop_data.data['0']['1']['lang'] && shop_item.shop_data.data['0']['1']['lang'][StoreLang]">
                          <strong :title="shop_item.shop_data.data['0']['1']['lang'][StoreLang]">{{ shop_item.shop_data.data['0']['1']['lang'][StoreLang].length > 30 ? shop_item.shop_data.data['0']['1']['lang'][StoreLang].substring(0,15) + '...' : shop_item.shop_data.data['0']['1']['lang'][StoreLang] }}</strong>
                        </template>
                        <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['1'] && shop_item.shop_data.data['0']['1']['val']">
                          <strong :title="shop_item.shop_data.data['0']['1']['val']">{{ shop_item.shop_data.data['0']['1']['val'].length > 30 ? shop_item.shop_data.data['0']['1']['val'].substring(0,15) + '...' : shop_item.shop_data.data['0']['1']['val'] }}</strong>
                        </template>
                    </b-col>
                    <b-col sm="12" lg="3">
                      <i class="fa fa-envelope"></i>

                        <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['29'] && shop_item.shop_data.data['0']['29']['lang'] && shop_item.shop_data.data['0']['29']['lang'][StoreLang]">
                          <strong>{{ shop_item.shop_data.data['0']['29']['lang'][StoreLang] }}</strong>
                        </template>
                        <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['29'] && shop_item.shop_data.data['0']['29']['val']">
                          <strong>{{ shop_item.shop_data.data['0']['29']['val'] }}</strong>
                        </template>
                    </b-col>
                    <b-col sm="12" lg="3">
                      <i class="fa fa-mobile-phone"></i>

                        <template v-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['30'] && shop_item.shop_data.data['0']['30']['lang'] && shop_item.shop_data.data['0']['30']['lang'][StoreLang]">
                          <strong>{{ shop_item.shop_data.data['0']['30']['lang'][StoreLang] }}</strong>
                        </template>
                        <template v-else-if="shop_item.shop_data.data && shop_item.shop_data.data['0'] && shop_item.shop_data.data['0']['30'] && shop_item.shop_data.data['0']['30']['val']">
                          <strong>{{ shop_item.shop_data.data['0']['30']['val'] }}</strong>
                        </template>
                    </b-col>
                  </b-row>
                </b-card-header>

                <b-card-body>
                  <template v-for="(bundle_item, bundle_item_index) in shop_item.bundle_list" v-if="f_searchUserShopBundle(bundle_item)">
                     <b-row @mouseover="d_hoverIndex = bundle_item_index" @mouseleave="d_hoverIndex = ''" :class="['cart-bundle-row']" :style="StoreDevice.isMobile ? 'cursor: pointer; border-bottom: solid 1px #dcdcdc; font-weight: 900;' : 'cursor: pointer; margin: 1px; border-bottom: solid 1px #dcdcdc; font-weight: 900;'">
                      <b-col sm="12" lg="6">
                        <template v-if="bundle_item.user_shop_bundle_data.data && bundle_item.user_shop_bundle_data.data['0'] && bundle_item.user_shop_bundle_data.data['0']['1'] && bundle_item.user_shop_bundle_data.data['0']['1']['lang'] && bundle_item.user_shop_bundle_data.data['0']['1']['lang'][StoreLang]">
                          <span :style="d_hoverIndex === bundle_item_index ? ' color: rgb(252, 0, 153, 1);' : ''">{{ bundle_item.user_shop_bundle_data.data['0']['1']['lang'][StoreLang] }}</span>
                        </template>
                        <template v-else-if="bundle_item.user_shop_bundle_data.data && bundle_item.user_shop_bundle_data.data['0'] && bundle_item.user_shop_bundle_data.data['0']['1'] && bundle_item.user_shop_bundle_data.data['0']['1']['val']">
                          <span :style="d_hoverIndex === bundle_item_index ? ' color: rgb(252, 0, 153, 1);' : ''">{{ bundle_item.user_shop_bundle_data.data['0']['1']['val'] }}</span>
                        </template>
                      </b-col>
                      <b-col sm="12" lg="2">
                        <template v-if="d_discountLoading">
                          <b-spinner variant="primary" style="width: 20px; height: 20px; margin-right: 10px;"></b-spinner>
                        </template>
                        <template v-else-if="d_bundleDiscounts && d_bundleDiscounts[bundle_item.user_shop_bundle_data.client_id]">
                          {{ f_calculateProductTotalPriceWithDiscount(bundle_item.product_list, bundle_item.user_shop_bundle_data.client_id) }}
                        </template>
                        <template v-else>
                          {{ f_calculateProductTotalPrice(bundle_item.product_list) }}
                        </template>
                      </b-col>
                      <b-col sm="12" lg="2"></b-col>
                      <b-col sm="12" lg="2">
                        <b-dropdown variant="white" size="sm" style="width: 100%; float: left;">
                          <template slot="button-content">
                            {{ StoreLangTranslation.data['process'][StoreLang] }}
                          </template>
                          <b-dropdown-item @click="f_cancelUserShopcartBundle(bundle_item.user_shopcart_bundle_data, shop_item.shop_data.cl)"><i class="fa fa-trash"></i> {{ StoreLangTranslation.data['cancel'][StoreLang] }} </b-dropdown-item>
                        </b-dropdown>
                      </b-col>
                    </b-row>

                    <template v-for="(product_item, product_item_index) in bundle_item.product_list" v-if="f_showCheckProduct(product_item.product)">
                      <b-row :class="['cart-product-row']" :style="StoreDevice.isMobile ? 'cursor: pointer; border-bottom: solid 1px #dcdcdc; margin-left: 10px;' : 'cursor: pointer; margin: 1px; border-bottom: solid 1px #dcdcdc; margin-left: 10px;'">
                        <b-col sm="12" lg="8">
                          <i @click="f_openProductIngredients(product_item.product)" style="border-radius: 10px; padding-right: 5px; margin: 3px; padding-left: 5px; width: 20px; background-color: lightblue; text-align: center;">{{ (product_item_index + 1).toString() }}</i>
                          <template v-if="product_item.product.data && product_item.product.data['0'] && product_item.product.data['0']['1'] && product_item.product.data['0']['1']['lang'] && product_item.product.data['0']['1']['lang'][StoreLang]">
                            <span>{{ product_item.product.data['0']['1']['lang'][StoreLang] }}</span>
                          </template>
                          <template v-else-if="product_item.product.data && product_item.product.data['0'] && product_item.product.data['0']['1'] && product_item.product.data['0']['1']['val']">
                            <span>{{ product_item.product.data['0']['1']['val'] }}</span>
                          </template>
                        </b-col>
                        <b-col sm="12" lg="2">
                        </b-col>
                        <b-col sm="12" lg="2">
                          <div style="text-align: center;">
                            <b-spinner v-if="d_discountLoading" variant="primary" style="width: 20px; height: 20px;"></b-spinner>
                            <span v-else :class="d_bundleDiscounts && d_bundleDiscounts[bundle_item.user_shop_bundle_data.client_id] ? 'underlined-price' : ''">
                              {{ f_calculateProductTotalPrice([product_item]) }}
                            </span>
                            <br/>
                          </div>
                          <div v-if="d_bundleDiscounts && d_bundleDiscounts[bundle_item.user_shop_bundle_data.client_id]" style="text-align: center;">
                            <span>{{ f_calculateProductTotalPriceWithDiscount([product_item], bundle_item.user_shop_bundle_data.client_id) }}</span>
                          </div>
                        </b-col>
                      </b-row>
                    </template>
                  </template>
                </b-card-body>
               </b-card>
            </template>

          </b-col>

          <b-col sm="12" lg="3">
            <b-button v-if="StoreShopCartList.data.length > 0" variant="warning" style="width: 100%" @click="f_userShopCartPay()">
              {{ StoreLangTranslation.data['approve_shopcart'][StoreLang] }}
              <i class="fa fa-angle-right"></i>
            </b-button>

            <b-card class="shopping-summary-card">
              <b-card-header >{{ StoreLangTranslation.data['order_brief'][StoreLang] }}</b-card-header>
              <b-row>
                <b-col sm="12" lg="5">
                  {{ StoreLangTranslation.data['product_count'][StoreLang] }}
                </b-col>
                <b-col sm="12" lg="1"> : </b-col>
                <b-col sm="12" lg="5">
                  {{ f_calculateShopcartBundleCount() }}
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12" lg="5">
                  {{ StoreLangTranslation.data['total'][StoreLang] }}
                </b-col>
                <b-col sm="12" lg="1"> : </b-col>
                <b-col sm="12" lg="5">
                  <b-spinner v-if="d_discountLoading" variant="primary" style="width: 20px; height: 20px; margin-right: 10px;"></b-spinner>
                  <span v-else>
                    {{ f_calculateAllBundleTotalPrice() }}
                  </span>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="12" lg="2"></b-col>
    </b-row>
  </div>
</template>


<script>

import { ClsUser } from '@/wam/modules/user';
import { ClsWdm } from '@/wam/modules/wdm';
import { ClsRoute } from '@/wam/modules/route';
import store from '@/store';
import { ServiceFunctions } from '@/wam/modules/service';
import {
  default as PageInfo
} from '@/components/widgets/PageInfo';
import { mapGetters } from 'vuex';
export default {
  name: 'user_shoppingcart',
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
    StoreShopCartList: 'StoreShopCartList',
    StoreCurrencyType: 'StoreCurrencyType',
  }),
  components: {
    PageInfo,
  },
  props: {},
  data () {
    return {
      d_exchange_data: {},//Kur değeri
      d_loading: false,
      d_selectedProductListForPayment: {
        'user_shopcart_bundle_client_id': '',
        'product_list': [],
        'show': false
      },
      d_selectedProductPaymentData: {
        'data': '',
        'show': false
      },
      d_selectedProductData: {
        'data': '',
        'show': false
      },
      d_paymentModal: {
        'data': '',
        'show': false
      },
      d_currencyType: '0', // 0 tl, 1 dollar
      d_user: '',
      d_hoverIndex: '',
      d_searchText: '',
      d_frontendClientID: '',
      d_frontendList: [],
      d_usrShpBundleList: [],
      d_shopOrderList: [],
      d_discountLoading: false,
      d_bundleDiscounts: {},
      d_institutionalDiscounts: false,
    };
  },
  created: function () {
    this.d_user = JSON.parse(localStorage.getItem('user'));
    this.d_userShopClientID = this.$route.query.user_shop_client_id;
    this.d_shopOrderList = this.StoreShopCartList.data;
    this.f_userShopCartBundleList();
  },
  beforeMount () {},
  mounted: function () {
    // console.log(this.StoreFrontendSettings);
    // console.log(this.d_usrShpBundWdm);
    // console.log('this.StoreShopCartList ', this.StoreShopCartList);
  },
  methods: {
    
    f_checkDiscount: function () {
      if (this.d_shopOrderList.length > 0) {
        this.d_discountLoading = true;
        let query = 'user_client_id=' + this.d_user.username;
        let data = {
          'user_shop_bundle_list': []
        };
        for (let shp_ind in this.d_shopOrderList) {
          for (let shp_bnd_ind in this.d_shopOrderList[shp_ind].bundle_list) {
            data.user_shop_bundle_list.push(this.d_shopOrderList[shp_ind].bundle_list[shp_bnd_ind].user_shop_bundle_data.client_id)
          }
        }
        ServiceFunctions.check_discount(query, data)
          .then(resp => {
            this.d_discountLoading = false;
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              if (resp.data.bundle_discount_list) {
                this.d_bundleDiscounts = resp.data.bundle_discount_list;
              } else {
                alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
              }
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
          });
      }
    },
    f_showCheckProduct: function (product_data) {
      let show_product = true;
      try {
        if (product_data.data['0']['48']['val']['value'] === '0') {
          show_product = false;
        }
      } catch(err) {}
      return show_product;
    },
    f_calculateShopcartBundleCount: function () {
      let total_count = 0;
      for (let i in this.StoreShopCartList.data) {
        total_count += this.StoreShopCartList.data[i].bundle_list.length;
      }
      return total_count;
    },
    f_userShopCartBundleList: function () {
      this.d_loading = true;
      let query = 'user_client_id=' + this.d_user.username;
      let data = {};
      ServiceFunctions.user_shopcart_bundle_list(query, data)
        .then(resp => {
          this.d_loading = false;
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_shopOrderList = resp.data.list;
            this.d_exchange_data = resp.data.exchange_data;
            this.f_checkDiscount();
            if (this.StoreShopCartList.status === 1) {
              this.$store.commit('MutationShopCartList', { 'status': 0, 'data': this.StoreShopCartList.data });
            } else {
              this.$store.commit('MutationShopCartList', { 'status': 1, 'data': this.StoreShopCartList.data });
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        }); 
    },
    f_userShopCartPay: function () {
      this.$router.push({ path: ClsRoute.f_getRoutePath('user_shoppingcart_payment', this.StoreLang), query: {} });
    },
    f_searchUserShopBundle: function (usr_shp_bund) {
      let res = false;
      if (this.d_searchText) {
        if (usr_shp_bund.w_id.toLocaleLowerCase().indexOf(this.d_searchText.toLocaleLowerCase()) !== -1) {
          res = true;
        }
      } else {
        res = true;
      }
      return res;
    },
    f_userShopBundleList: function () {
      let query = 'user_client_id=' + this.d_user.username;
      query += '&user_shop_client_id=' + this.d_userShopClientID;
      let data = {};
      ServiceFunctions.user_shop_bundle_list(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.list) {
              this.d_usrShpBundleList = resp.data.list;
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_cancelUserShopcartBundle: function (user_shopcart_bundle_data, user_shop_client_id) {
      let query = 'user_client_id=' + this.d_user.username;
      query += '&user_shopcart_bundle_client_id=' + user_shopcart_bundle_data.client_id;
      query += '&user_shop_client_id=' + user_shop_client_id;
      let data = {};
      ServiceFunctions.user_shopcart_bundle_cancel(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.cancel_status === 'completed') {
              this.f_userShopCartBundleList();
              alert(this.StoreLangTranslation.data['cancel_completed'][this.StoreLang]);
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_calculateBundleTotalPrice: function (bundle_products) {
      let currency_text = this.StoreCurrencyType.label;
      let total_amount = 0;
      let exchange_amount = 1;
      let tl_price = null;
      let non_tl_price = null;
      let product_cur_type = null;
      let cur_fixed = true;
      for (let product_index in bundle_products) {
        tl_price = null;
        non_tl_price = null;
        try {//currency_list
          for (let currency_amount_index in bundle_products[product_index].product.data['0']['25'].list) {
            let currency_amount_item = bundle_products[product_index].product.data['0']['25'].list[currency_amount_index];
            product_cur_type = bundle_products[product_index].product.data['0']['25'].list[currency_amount_index]['26']['val']['value'];
            let exchange_cur_type = this.d_exchange_data['system'][product_cur_type];
            let page_cur_type = this.d_exchange_data['system'][this.StoreCurrencyType.value];
            if (page_cur_type != null){
              if (exchange_cur_type != null){
                if(this.d_exchange_data[page_cur_type] != null){
                  exchange_amount = parseFloat(this.d_exchange_data[page_cur_type][exchange_cur_type]);
                }
              }
            }
            if(currency_amount_item['64'] && currency_amount_item['64']['val'] && currency_amount_item['64']['val']['value'] &&currency_amount_item['64']['val']['value'] === '1'){
              cur_fixed = false;
            }
            else{
              cur_fixed = true;
            }
            //Gelen ürünün para birimine göre atama
            if(product_cur_type === '0'){ 
              tl_price = parseFloat(currency_amount_item['27']['val']);
            }
            else{
              non_tl_price = parseFloat(currency_amount_item['27']['val']);
            }
            }
            try {
              if (cur_fixed){//Kur sabit/fixed
                  if (this.StoreCurrencyType.value ==='0' && tl_price !== null) {
                    total_amount += tl_price;
                  }
                  else if (this.StoreCurrencyType.value ==='1' && non_tl_price !== null){
                    total_amount += non_tl_price;
                  }
                  else{
                    total_amount += (non_tl_price * exchange_amount) + (tl_price * exchange_amount);
                  }
                }
                else{//Kur değeri Güncel
    
                  if(this.StoreCurrencyType.value ==='0'){
                    //Sayfa para birimi tl ise
                    if(tl_price !== null){
                      total_amount += tl_price;
                    }
                    else{
                      total_amount += non_tl_price * exchange_amount;
                    }
                  }
                  else{
                    //sayfa para birimide dolar ise
                    if(non_tl_price !== null){
                      total_amount += non_tl_price;
                    }
                    else{
                      total_amount += tl_price * exchange_amount;
                    }
                  }
                }  
            } catch(err) {}
          
        } catch(err) {}
      }
      return total_amount.toFixed(2) + ' ' + currency_text; 
    },
    f_calculateProductTotalPriceWithDiscount: function (bundle_products, bundle_client_id) {
      let max_discount_percent = 0;
      if (this.d_bundleDiscounts && this.d_bundleDiscounts[bundle_client_id]) {
        max_discount_percent = this.d_bundleDiscounts[bundle_client_id]['max_discount_percent'];
      }
      let currency_text = this.StoreCurrencyType.label;
      let total_amount = 0;
      total_amount = parseFloat(this.f_calculateProductTotalPrice(bundle_products));
      total_amount = total_amount * ((100 - max_discount_percent) / 100);
      return total_amount + ' ' + currency_text;
    },
    f_userShopCartBundleOrderList: function () {
      let query = 'user_client_id=' + this.d_user.username;
      let data = {};
      ServiceFunctions.user_shopcart_bundle_order_list(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_shopOrderList = resp.data.list;
            if (this.StoreShopCartOrderList.status === 1) {
              this.$store.commit('MutationShopCartOrderList', { 'status': 0, 'data': this.StoreShopCartOrderList.data });
            } else {
              this.$store.commit('MutationShopCartOrderList', { 'status': 1, 'data': this.StoreShopCartOrderList.data });
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_userShopCartBundleActiveList: function () {
      let query = 'user_client_id=' + this.d_user.username;
      let data = {};
      ServiceFunctions.user_shopcart_bundle_active_list(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            this.d_shopOrderList = resp.data.list;
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
    f_getOptionLabel: function (option_value, options) {
      // console.log('option_value : ', option_value);
      // console.log('options : ', options);
      let option_label = '';
      for (let i in options) {
        if (options[i].value === option_value) {
          option_label = options[i].translation[this.StoreLang];
          break;
        }
      }
      return option_label;
    },
    f_openPaymentScreen: function (product_list, user_shopcart_bundle_client_id) {
      this.d_selectedProductListForPayment.product_list = product_list;
      this.d_selectedProductListForPayment.user_shopcart_bundle_client_id = user_shopcart_bundle_client_id;
      this.d_selectedProductListForPayment.show = true;
    },
    f_openProductIngredients: function (product_data) {
      this.d_selectedProductData.show = true;
      this.d_selectedProductData.data = product_data;
    },
    f_openProductPaymentIngredients: function (payment_data) {
      this.d_selectedProductPaymentData.show = true;
      this.d_selectedProductPaymentData.data = payment_data;
    },
    f_calculateAllBundleTotalPrice: function () {
      let currency_text = this.StoreCurrencyType.label;
      let total_amount = 0;
      let exchange_amount = 1;
      let tl_price = null;
      let non_tl_price = null;
      let product_cur_type = null;
      let cur_fixed = true;
      //console.log(this.StoreShopCartList.data);
      for (let shop_index in this.StoreShopCartList.data) {
        for (let bundle_index in this.StoreShopCartList.data[shop_index].bundle_list) {
          let bundle_client_id = this.StoreShopCartList.data[shop_index].bundle_list[bundle_index].user_shop_bundle_data.client_id;
          if (this.d_bundleDiscounts && this.d_bundleDiscounts[bundle_client_id]) {
            //indirim var ise
            let max_discount_percent = 0;
            max_discount_percent = this.d_bundleDiscounts[this.StoreShopCartList.data[shop_index].bundle_list[bundle_index].user_shop_bundle_data.client_id]['max_discount_percent'];
            let product_amount = parseFloat(this.f_calculateBundleTotalPrice(this.StoreShopCartList.data[shop_index].bundle_list[bundle_index].product_list));
            total_amount += product_amount * ((100 - max_discount_percent) / 100);
          } 
          else {//İndirim yok ise
            try{
              total_amount += parseFloat(this.f_calculateBundleTotalPrice(this.StoreShopCartList.data[shop_index].bundle_list[bundle_index].product_list));
            } catch(err){}             

          }
        }
      }
      return total_amount + ' ' + currency_text;
    },
    f_calculateProductTotalPrice: function (bundle_products) {
      let currency_text = this.StoreCurrencyType.label;
      let total_amount = 0;
      let exchange_amount = 1;
      let tl_price = null;
      let non_tl_price = null;
      let product_cur_type = null;
      let cur_fixed = true;
      for (let product_index in bundle_products) {
        tl_price = null;
        non_tl_price = null;
        try {//currency_list
          for (let currency_amount_index in bundle_products[product_index].product.data['0']['25'].list) {
            let currency_amount_item = bundle_products[product_index].product.data['0']['25'].list[currency_amount_index];
            product_cur_type = bundle_products[product_index].product.data['0']['25'].list[currency_amount_index]['26']['val']['value'];
            let exchange_cur_type = this.d_exchange_data['system'][product_cur_type];
            let page_cur_type = this.d_exchange_data['system'][this.StoreCurrencyType.value];
            if (page_cur_type != null){
              if (exchange_cur_type != null){
                if(this.d_exchange_data[page_cur_type] != null){
                  exchange_amount = parseFloat(this.d_exchange_data[page_cur_type][exchange_cur_type]);
                }
              }
            }
            if(currency_amount_item['64'] && currency_amount_item['64']['val'] && currency_amount_item['64']['val']['value'] &&currency_amount_item['64']['val']['value'] === '1'){
              cur_fixed = false;
            }
            else{
              cur_fixed = true;
            }
            //Gelen ürünün para birimine göre atama
            if(product_cur_type === '0'){ 
              tl_price = parseFloat(currency_amount_item['27']['val']);
            }
            else{
              non_tl_price = parseFloat(currency_amount_item['27']['val']);
            }
            }
            try {
              if (cur_fixed){//Kur sabit/fixed
                  if (this.StoreCurrencyType.value ==='0' && tl_price !== null) {
                    total_amount += tl_price;
                  }
                  else if (this.StoreCurrencyType.value ==='1' && non_tl_price !== null){
                    total_amount += non_tl_price;
                  }
                  else{
                    total_amount += (non_tl_price * exchange_amount) + (tl_price * exchange_amount);
                  }
                }
                else{//Kur değeri Güncel
    
                  if(this.StoreCurrencyType.value ==='0'){
                    //Sayfa para birimi tl ise
                    if(tl_price !== null){
                      total_amount += tl_price;
                    }
                    else{
                      total_amount += non_tl_price * exchange_amount;
                    }
                  }
                  else{
                    //sayfa para birimide dolar ise
                    if(non_tl_price !== null){
                      total_amount += non_tl_price;
                    }
                    else{
                      total_amount += tl_price * exchange_amount;
                    }
                  }
                }  
            } catch(err) {}
          
        } catch(err) {}
      }
      return total_amount.toFixed(2) + ' ' + currency_text; 
    },
  },
  watch: {}
};

</script>

<style scoped>

.underlined-price {
  font-size: 14px;
  color: black;
  position: relative;
  display: inline-block;
}

.underlined-price::after {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;           /* Metnin tam ortası */
  width: 100%;
  height: 2px;
  background: red;
  transform: rotate(-25deg) translateY(-50%);
  transform-origin: center;
  pointer-events: none;
}

/* Kart genel yapısı (b-card) */
.b-card {
  background: #f8fafc !important;
  border: 1px solid #dbe3ef !important;
  border-radius: 14px !important;
  box-shadow: 0 2px 8px rgba(30, 64, 175, 0.06) !important;
  margin-bottom: 25px !important;
  transition: all 0.25s ease;
}

/*.b-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 16px rgba(30, 64, 175, 0.10) !important;
}*/

/* Kart header (üst bilgi) */
.b-card-header {
  background: #f8fafc !important;
  border-bottom: 1px solid #e2e8f0 !important;
  border-radius: 14px 14px 0 0 !important;
  padding: 14px !important;
}

/* Kart header içindeki row */
.b-card-header .row,
.b-card-header .b-row {
  background: #edf2f7 !important;
  border-radius: 10px;
  padding: 10px !important;
  border: 1px solid #dbe3ef !important;
}

/* Header ikonları */
.b-card-header i {
  font-size: 17px;
  margin-right: 5px;
  color: #64748b;
}

/* Header strong yazılar */
.b-card-header strong {
  font-size: 15px;
  color: #0f172a;
}

.cart-bundle-row {
  background: #fff7cc !important;
  border-bottom: 1px solid #e2e8f0 !important;
  font-weight: 600;
  padding: 12px 5px !important;
  border-radius: 10px;
  transition: all 0.15s ease;
}

.cart-bundle-row:hover {
  background: #ffe98a !important;
  /*transform: translateY(-2px);*/
}

.cart-product-row {
  background: #f1f5f9 !important;
  border-bottom: 1px solid #e2e8f0 !important;
  border-radius: 10px;
  padding: 8px 5px !important;
  margin-left: 15px !important;
  transition: all 0.15s ease;
}

.cart-product-row:hover {
  background: #e2e8f0 !important;
}


/* Ürün sıra numarası */
.cart-product-row i {
  background: #e0f2fe !important;
  color: #0369a1 !important;
  border-radius: 10px;
  padding: 3px 8px;
}

.shopping-summary-card {
  background: #f8fafc !important;
  border: 1px solid #dbe3ef !important;
  border-radius: 14px !important;
  box-shadow: 0 2px 8px rgba(30, 64, 175, 0.06);
}

.shopping-summary-card .b-card-header {
  font-size: 17px;
  font-weight: 600;
  color: #0f172a;
  border-bottom: 1px solid #dbe3ef !important;
}

/* Özet satırları */
.shopping-summary-card .b-row {
  margin: 8px 0;
  padding: 6px;
  border-radius: 8px;
  background: #f1f5f9;
  border: 1px solid #dbe3ef;
}

.shoppingcart-title-row {
  border-bottom: 1px solid #e2e8f0 !important;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.shoppingcart-title-row i {
  font-size: 20px;
  color: #475569;
  margin-right: 6px;
}

.shoppingcart-title-row {
  font-size: 20px;
  font-weight: 600;
  color: #0f172a;
}


</style>